import RequestCache from "./RequestCache";

export default class Reasons extends RequestCache {
    get cacheInterval() {
        return 7;
    }

    get link() {
        return this.links.reasons;
    }

    async getAll() {
        return await this.getAllFiltered([], this.getSortField("title"));
    }
}
